export default __webpack_public_path__ + "static/media/Financial.8400199b.png";